document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('VerdenstoreChatbot');
  if (!root) return;

  var toggle = document.getElementById('VerdenstoreChatToggle');
  var panel = document.getElementById('VerdenstoreChatPanel');
  var closeBtn = document.getElementById('VerdenstoreChatClose');
  var body = document.getElementById('VerdenstoreChatBody');
  var form = document.getElementById('VerdenstoreChatForm');
  var input = document.getElementById('VerdenstoreChatInput');
  var quickWrap = document.getElementById('VerdenstoreQuickOptions');
  var contactUrl = root.getAttribute('data-contact-url') || '/pages/kontakt';

  var products = [];
  try {
    products = JSON.parse(document.getElementById('VerdenstoreChatProducts').textContent || '[]');
  } catch (e) {
    products = [];
  }

  // --- stan rozmowy (kontekst) ---
  var lastProduct = null;
  var turns = 0;

  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    input.focus();
  }
  function closePanel() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    if (panel.hidden) { openPanel(); } else { closePanel(); }
  });
  closeBtn.addEventListener('click', closePanel);

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function normalize(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '') // usuń polskie znaki diakrytyczne do dopasowań
      .replace(/[^\p{L}\p{N}\s]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function addMessage(text, from) {
    var el = document.createElement('div');
    el.className = 'vd-chat__msg vd-chat__msg--' + (from === 'user' ? 'user' : 'bot');
    el.textContent = text;
    body.appendChild(el);
    body.scrollTop = body.scrollHeight;
    return el;
  }

  function showTyping(cb) {
    var el = document.createElement('div');
    el.className = 'vd-chat__msg vd-chat__msg--bot vd-chat__msg--typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    body.appendChild(el);
    body.scrollTop = body.scrollHeight;
    var delay = 380 + Math.random() * 420;
    setTimeout(function () {
      el.remove();
      cb();
    }, delay);
  }

  function say(text) {
    showTyping(function () { addMessage(text, 'bot'); });
  }

  function addProductResults(list) {
    var wrap = document.createElement('div');
    wrap.className = 'vd-chat__results';
    if (list.length === 0) {
      var none = document.createElement('div');
      none.className = 'vd-chat__msg vd-chat__msg--bot';
      none.textContent = 'Nie znalazłam idealnego dopasowania — zobacz cały katalog, na pewno coś tam pasuje.';
      body.appendChild(none);
    } else {
      list.forEach(function (p) {
        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'vd-chat__product';
        a.innerHTML = '<span class="vd-chat__product-title">' + p.title + '</span><span class="vd-chat__product-price">' + p.price + '</span>';
        a.addEventListener('click', function () { lastProduct = p; });
        wrap.appendChild(a);
      });
      body.appendChild(wrap);
    }
    var allLink = document.createElement('a');
    allLink.href = '/collections/all';
    allLink.className = 'vd-chat__chip';
    allLink.textContent = 'Zobacz wszystkie produkty';
    var chipWrap = document.createElement('div');
    chipWrap.className = 'vd-chat__quick';
    chipWrap.appendChild(allLink);
    body.appendChild(chipWrap);
    body.scrollTop = body.scrollHeight;
  }

  function showCategoryOptions() {
    say(pick([
      'Jasne, powiedz czego szukasz — albo wybierz kategorię niżej:',
      'Dobrze, pomogę Ci trafić w dobry produkt. Co Cię interesuje?'
    ]));
    var categories = [
      { label: 'Do kuchni', tag: 'kuchnia' },
      { label: 'Do prania / czystości', tag: 'pranie' },
      { label: 'Do domu i relaksu', tag: 'świece' },
      { label: 'Do uprawy ziół', tag: 'uprawa' },
      { label: 'Na prezent', tag: 'prezent' }
    ];
    var wrap = document.createElement('div');
    wrap.className = 'vd-chat__quick';
    categories.forEach(function (c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vd-chat__chip';
      btn.textContent = c.label;
      btn.addEventListener('click', function () {
        addMessage(c.label, 'user');
        recommendByTag(c.tag);
      });
      wrap.appendChild(btn);
    });
    setTimeout(function () {
      body.appendChild(wrap);
      body.scrollTop = body.scrollHeight;
    }, 850);
  }

  function recommendByTag(tag) {
    var matches = products.filter(function (p) {
      return p.available && p.tags.some(function (t) { return normalize(t).indexOf(tag) !== -1; });
    }).slice(0, 3);
    showTyping(function () { addProductResults(matches); });
  }

  // --- rozpoznawanie konkretnego produktu w wiadomości ---
  function findProductInText(normText) {
    var best = null;
    var bestScore = 0;
    products.forEach(function (p) {
      var haystacks = [normalize(p.title)].concat((p.tags || []).map(normalize));
      var words = normalize(p.title).split(' ').filter(function (w) { return w.length >= 4; });
      var score = 0;
      words.forEach(function (w) { if (normText.indexOf(w) !== -1) score += 2; });
      haystacks.forEach(function (h) { if (h && normText.indexOf(h) !== -1) score += 1; });
      if (score > bestScore) { bestScore = score; best = p; }
    });
    return bestScore > 0 ? best : null;
  }

  function productReply(p, normText) {
    lastProduct = p;
    var isPrice = /\b(cena|kosztuj|ile|za ile|koszt)\b/.test(normText);
    var isStock = /\b(dostepn|na stanie|w magazynie|jest w sprzedazy|mozna kupic)\b/.test(normText);
    var isCare = /\b(sklad|material|jak dbac|jak uzywac|pranie|czyszczenie|myc|pielegnacj)\b/.test(normText);

    if (isPrice) {
      return p.title + ' kosztuje ' + p.price + '. ' + (p.available ? 'Jest dostępny — link poniżej.' : 'Chwilowo brak na stanie, ale zerknij na opis, wracamy z zapasem szybko.');
    }
    if (isStock) {
      return p.available ? p.title + ' jest dostępny, możesz zamawiać od ręki.' : p.title + ' jest chwilowo niedostępny — napisz do nas, damy znać jak wróci na stan.';
    }
    if (isCare) {
      return (p.description ? p.description + ' ' : '') + 'Pełny skład i wskazówki pielęgnacji znajdziesz na stronie produktu, w sekcji "Skład i pielęgnacja".';
    }
    return (p.description || (p.title + '.')) + ' Cena: ' + p.price + '.';
  }

  var faqEntries = [
    { keywords: ['dostaw', 'wysyl', 'kurier', 'paczk', 'ile dni', 'kiedy dotrze'],
      answers: ['Zamówienia nadajemy w 24-48h roboczych, dostawa kurierem trwa zwykle 1-2 dni robocze. Darmowa wysyłka od 200 zł.'] },
    { keywords: ['zwrot', 'odstapi', 'oddac'],
      answers: ['Masz 14 dni na zwrot bez podawania przyczyny. Szczegóły znajdziesz w regulaminie zwrotów w stopce strony.'] },
    { keywords: ['reklamacj', 'wadliw', 'uszkodz', 'nie dziala'],
      answers: ['Jeśli produkt dotarł uszkodzony lub masz inny problem, napisz do nas na kontakt@verdenstore.pl — rozpatrujemy reklamacje w ciągu 14 dni.'] },
    { keywords: ['plat', 'karta', 'blik', 'przelew', 'raty'],
      answers: ['Płatności realizujemy przez bezpieczne bramki płatności dostępne przy zamówieniu (karta, BLIK, przelew — w zależności od dostępnych metod w sklepie).'] },
    { keywords: ['skladniki og', 'z czego jest zrobiony sklep', 'sklad', 'material', 'z czego'],
      answers: ['Każdy produkt ma pełny opis składu i materiałów na swojej stronie, w sekcji opisu i "Skład i pielęgnacja". Powiedz, o który produkt pytasz, a podpowiem konkretnie.'] },
    { keywords: ['rabat', 'kod', 'promocj', 'znizk', 'kupon'],
      answers: ['Zapisz się do newslettera na dole strony głównej — dostaniesz kod rabatowy na pierwsze zamówienie.'] },
    { keywords: ['prezent', 'na prezent', 'gift'],
      answers: ['Świetny pomysł — świeca sojowa i zestaw woskowijek najlepiej sprawdzają się jako prezent. Chcesz, żebym coś polecił konkretnie?'] },
    { keywords: ['gdzie produkowane', 'skad', 'polska', 'polscy producenci'],
      answers: ['Współpracujemy ze sprawdzonymi, polskimi producentami — nie z masowym importem. Stawiamy na jakość i trwałość, nie na ilość.'] },
    { keywords: ['kontakt', 'telefon', 'zadzwonic', 'email', 'mail'],
      answers: ['Najszybciej dogadasz się z nami mailowo: kontakt@verdenstore.pl, albo przez formularz kontaktowy na stronie.'] },
    { keywords: ['godziny', 'kiedy odpisujecie', 'czas odpowiedzi'],
      answers: ['Na wiadomości odpisujemy w dni robocze, zwykle w ciągu 24h.'] },
    { keywords: ['eko', 'ekologiczn', 'zero waste', 'plastik'],
      answers: ['Cała oferta to proste, trwałe zamienniki jednorazowego plastiku — bez greenwashingu i bez przesadzonych obietnic. Każdy produkt ma jasno opisane, co realnie zastępuje.'] }
  ];

  function handleFaqQuery(normText) {
    var found = faqEntries.find(function (entry) {
      return entry.keywords.some(function (k) { return normText.indexOf(normalize(k)) !== -1; });
    });
    if (found) {
      say(pick(found.answers));
      return true;
    }
    return false;
  }

  var greetingWords = ['czesc', 'hej', 'siema', 'witam', 'dzien dobry', 'halo', 'yo'];
  var thanksWords = ['dzieki', 'dziekuje', 'super', 'spoko', 'dzieki wielkie', 'ok dzieki', 'extra', 'git'];
  var whoAreYouWords = ['kim jestes', 'jestes botem', 'jestes ai', 'jestes czlowiekiem', 'jestes prawdziwa osoba', 'rozmawiam z botem', 'to bot'];
  var byeWords = ['pa', 'do widzenia', 'narazie', 'na razie', 'koniec'];

  function containsAny(normText, list) {
    return list.some(function (w) { return normText.indexOf(normalize(w)) !== -1; });
  }

  function handleMessage(rawText) {
    var normText = normalize(rawText);
    turns++;

    if (containsAny(normText, whoAreYouWords)) {
      say('Jestem asystentem Verdenstore działającym na regułach — pomagam wybrać produkt i odpowiadam na częste pytania. Nie jestem człowiekiem, ale znam sklep na wylot. W trudniejszych sprawach przekieruję Cię do zespołu.');
      return;
    }
    if (containsAny(normText, greetingWords) && normText.split(' ').length <= 4) {
      say(pick([
        'Cześć! W czym mogę pomóc — szukasz konkretnego produktu, czy masz pytanie o zamówienie?',
        'Hej! Miło Cię widzieć. Powiedz, czego szukasz, albo zapytaj o dostawę, zwroty czy skład.'
      ]));
      return;
    }
    if (containsAny(normText, thanksWords) && normText.split(' ').length <= 4) {
      say(pick([
        'Nie ma za co! Jakby coś jeszcze przyszło Ci do głowy, pisz śmiało.',
        'Cała przyjemność. Powodzenia z zakupami!'
      ]));
      return;
    }
    if (containsAny(normText, byeWords) && normText.split(' ').length <= 3) {
      say('Do zobaczenia! Gdybyś miał/a pytanie później, jestem tutaj.');
      return;
    }

    // konkretny produkt wspomniany w wiadomości
    var mentioned = findProductInText(normText);
    if (mentioned) {
      say(productReply(mentioned, normText));
      return;
    }

    // pytanie kontekstowe o ostatnio wspomniany produkt ("a ile to kosztuje?", "czy jest dostepny?")
    if (lastProduct && /\b(a ile|ile to|czy jest|dostepn|cena|kosztuj)\b/.test(normText) && normText.split(' ').length <= 6) {
      say(productReply(lastProduct, normText));
      return;
    }

    // pytanie o polecenie / dobór produktu
    if (/\b(polecisz|polecacie|szukam|potrzebuje|potrzebuje czegos|co wybrac|pomozesz wybrac|dobierz)\b/.test(normText)) {
      showCategoryOptions();
      return;
    }

    if (handleFaqQuery(normText)) return;

    // fallback — ale zycz, nie od razu poddanie sie
    showTyping(function () {
      var el = addMessage(pick([
        'Nie mam gotowej odpowiedzi na to pytanie, ale mogę pomóc Ci wybrać produkt albo skierować do zespołu.',
        'Tego akurat nie wiem na pewno — chcesz, żebym pokazał produkty, albo wolisz napisać bezpośrednio do nas?'
      ]), 'bot');
      var wrap = document.createElement('div');
      wrap.className = 'vd-chat__quick';
      wrap.style.marginTop = '0.5rem';

      var pickBtn = document.createElement('button');
      pickBtn.type = 'button';
      pickBtn.className = 'vd-chat__chip';
      pickBtn.textContent = 'Pokaż mi produkty';
      pickBtn.addEventListener('click', function () {
        addMessage(pickBtn.textContent, 'user');
        showCategoryOptions();
      });
      wrap.appendChild(pickBtn);

      var link = document.createElement('a');
      link.href = contactUrl;
      link.className = 'vd-chat__chip';
      link.textContent = 'Napisz do nas';
      wrap.appendChild(link);

      body.appendChild(wrap);
      body.scrollTop = body.scrollHeight;
    });
  }

  quickWrap.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-intent]');
    if (!btn) return;
    var intent = btn.getAttribute('data-intent');
    addMessage(btn.textContent, 'user');
    if (intent === 'pick') {
      showCategoryOptions();
    } else if (intent === 'faq') {
      say('Napisz swoje pytanie poniżej (np. o dostawę, zwroty, skład, konkretny produkt) — postaram się pomóc.');
    }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text) return;
    addMessage(text, 'user');
    input.value = '';
    handleMessage(text);
  });
});
